import { DetailTable } from '../../../mapping-classes/detail-table';

export class CreditorListings implements DetailTable {
  shieldedText = 'Afgeschermd';
  restrictedData: boolean;
  title: string;
  rowHeaders: string[];
  rowData: any[];
  errorText: string;

  constructor(creditorListings: any) {
    if (!creditorListings) {
      this.createErrorMessage();
    } else {
      this.rowHeaders = [];
      this.rowData = [];
      this.setRowHeaders();
      this.setRowData(creditorListings);
    }
  }

  createErrorMessage() {
    this.errorText = '';
  }

  setRowHeaders() {
    this.rowHeaders = [
      'incassantName',
      'incassantId',
    ];
  }

  setRowData(basicTableData) {
    basicTableData.forEach((details) => {
      this.rowData.push(details);
    });
  }
}
